import { Route, Routes } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Creches from "./pages/Creches";
import CrecheDetail from "./pages/CrecheDetail";
import Activites from "./pages/Activites";
import Tarifs from "./pages/Tarifs";
import PreInscription from "./pages/PreInscription";
import Entreprises from "./pages/Entreprises";
import NousRejoindre from "./pages/NousRejoindre";
import ReseauxSociaux from "./pages/ReseauxSociaux";
import MentionsLegales from "./pages/MentionsLegales";
import NotFound from "./pages/NotFound";

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/nos-micro-creches" element={<Creches />} />
        <Route path="/micro-creches/:slug" element={<CrecheDetail />} />
        <Route path="/nos-activites" element={<Activites />} />
        <Route path="/tarifs" element={<Tarifs />} />
        <Route path="/pre-inscription" element={<PreInscription />} />
        <Route path="/entreprises" element={<Entreprises />} />
        <Route path="/nous-rejoindre" element={<NousRejoindre />} />
        <Route path="/reseaux-sociaux" element={<ReseauxSociaux />} />
        <Route path="/mentions-legales" element={<MentionsLegales />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
